/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Concepts_TitleInputs */

const en_projects_concepts_title = /** @type {(inputs: Projects_Concepts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideas, made tangible.`)
};

const lv_projects_concepts_title = /** @type {(inputs: Projects_Concepts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idejas, kas kļūst taustāmas.`)
};

/**
* | output |
* | --- |
* | "Ideas, made tangible." |
*
* @param {Projects_Concepts_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_concepts_title = /** @type {((inputs?: Projects_Concepts_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Concepts_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_concepts_title(inputs)
	return en_projects_concepts_title(inputs)
});